import hyperdom from 'hyperdom'
import FakePaymentMethod from './fakePaymentMethod.jsx'

export default class UnknownPaymentMethod extends FakePaymentMethod {
  constructor (payment) {
    super(payment)
    this.displayName = 'Unknown Payment'
  }

  render () {
    return <div class='o-accent-box'>
      {this.payment.renderPaymentMethodSelection({noDetails: false})}
      <div>
        {this.billingAddress}
        <div class='payment-details'>
          <h2 class='u-margin-top-medium'>Unknown Payment</h2>
        </div>
      </div>
    </div>
  }

  book () {
    return this.payment.booking.pay(this.payment.calculatePaymentAmount(), 'unknown')
  }
}
